import React from "react";
import { useTranslation } from "react-i18next";
import "./ModalV2Buttons.sass";

export default function ModalV2Buttons({
  onCancel,
  onConfirm,
  cancelText,
  confirmText,
  cancelDisabled = false,
  confirmDisabled = false,
  confirmLoading = false,
  variant = "primary",
}) {
  const { t } = useTranslation();
  return (
    <div className="ModalV2Buttons">
      <button
        type="button"
        className="ModalV2Buttons__btn ModalV2Buttons__btn--cancel"
        onClick={onCancel}
        disabled={cancelDisabled}
      >
        {cancelText ?? t("sharedUi.common.cancel", { defaultValue: "Cancel" })}
      </button>

      <button
        type="button"
        className={`ModalV2Buttons__btn ModalV2Buttons__btn--${variant}`}
        onClick={onConfirm}
        disabled={confirmDisabled || confirmLoading}
      >
        {confirmLoading
          ? t("sharedUi.common.loading", { defaultValue: "Loading..." })
          : confirmText ?? t("sharedUi.common.continue", { defaultValue: "Continue" })}
      </button>
    </div>
  );
}
